import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [],total:0,error: "", message: "" }


export const chargebackAction = createAsyncThunk(
    'get-chargeback',
    async (data, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams();
            if (data.page !== undefined && data.page !== null) params.append('page', data.page);
            if (data.limit !== undefined && data.limit !== null) params.append('limit', data.limit);
            if (data.startDate && data.startDate !== 'undefined' && data.startDate !== null) params.append('startDate', data.startDate);
            if (data.endDate && data.endDate !== 'undefined' && data.endDate !== null) params.append('endDate', data.endDate);
            if (data.userId && data.userId !== 'undefined' && data.userId !== null) params.append('userId', data.userId);
            if (data.partnerId && data.partnerId !== 'undefined' && data.partnerId !== null) params.append('partner_id', data.partnerId);
            if (data.type && data.type !== 'undefined') params.append('type', data.type);
            
            const res = await axios.get(`/admins/api/chargeback/postback/logs?${params.toString()}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const chargebackkSlice = createSlice({
    name: 'get-chargeback',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(chargebackAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(chargebackAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData
            })
            builder.addCase(chargebackAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData

            })
        },

})



export const chargebackReducer = chargebackkSlice.reducer